import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Badge } from "react-bootstrap";
import {
  BucketSquare,
  Call,
  ChemicalGlass,
  Cup,
  MessageQuestion,
  MessageText1,
  QuoteUpSquare,
  UserSquare,
} from "iconsax-react";

import * as ROUTE from "../../routes";

import userType from "../../redux/actions/user/userType";

import DesktopNavbarComponent from "../../components/public/navbar/desktopNavbar";
import ResponsiveNavbarComponent from "../../components/public/navbar/responsiveNavbar";

import { StyledNavbar, StyledLogoutCurve } from "./navbarStyled";
import { StyledSearchIcon } from "../../components/public/navbar/styledNavbars";

const NavbarContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userDetail);
  const userMessage = useSelector((state) => state.userMessage);

  const handleLogoutUser = (e) => {
    e.preventDefault();
    dispatch({ type: userType.START_LOGIN_OUT, refresh:user.userRefreshToken });
  };

  const profileDetails = {
    fullName: user.isLogin
      ? user.userDetail.length &&
        `${user.userDetail[0].first_name}  ${user.userDetail[0].last_name}`
      : "",
    image:
      user.isLogin &&
      user.userDetail[0].usermeta.img_addr &&
      user.userDetail[0].usermeta.img_addr,
    unreadMessages: user.isLogin ? userMessage.count_unread_message : 0,
    balance: user?.userDetail[0]?.usermeta?.balance
  };

  const profileListItems = [
    {
      title: "مشاهده پروفایل",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_PROFILE}`,
      icon: <UserSquare size="20" />,
    },
    {
      title: "آزمایشگاه",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_EXPERIMENT}`,
      icon: <ChemicalGlass size="20" />,
    },
    {
      title: "پیام‌ جدید",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_MESSAGE_LIST}`,
      icon: <MessageText1 size="20" />,
      notification: !profileDetails.unreadMessages ? (
        0
      ) : (
        <Badge pill bg="danger">
          {profileDetails.unreadMessages}
        </Badge>
      ),
    },
    {
      title: "خروج",
      icon: <StyledLogoutCurve size="20" />,
      handleLogout: handleLogoutUser,
    },
  ];

  const sideProfileListItems = [
    {
      title: "مشاهده پروفایل",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_PROFILE}`,
      icon: <UserSquare variant="Bold" size="20" />,
      borderTop: true,
    },
    {
      title: "آزمایشگاه",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_EXPERIMENT}`,
      icon: <ChemicalGlass variant="Bold" size="20" />,
    },
    {
      title: "پیام‌ جدید",
      path: `/${user.userRole}/${ROUTE.ROUTE_MY_MESSAGE_LIST}`,
      icon: <MessageText1 variant="Bold" size="20" />,
      notification: !profileDetails.unreadMessages ? (
        0
      ) : (
        <Badge pill bg="danger">
          {profileDetails.unreadMessages}
        </Badge>
      ),
    },
    {
      title: "خروج",
      icon: <StyledLogoutCurve variant="Bold" size="20" className="text-danger" />,
      handleLogout: handleLogoutUser,
    },
  ];

  const sideBarList = [
    {
      title: "آزمایش‌ها",
      path: ROUTE.ROUTE_SIMS,
      icon: <BucketSquare variant="Bold" size="20" />,
      borderTop: true,
    },
    // TODO: #Future feature
    // {
    //   title: "مسابقات",
    //   path: "#", // TODO: Create tournaments route when it's UI is completed
    //   icon: <Cup variant="Bold" size="20" />,
    // },
    {
      title: "بلاگ",
      href: ROUTE.ROUTE_BLOG,
      icon: <QuoteUpSquare variant="Bold" size="20" />,
    },
    {
      title: "جست و جو",
      path: ROUTE.ROUTE_SEARCH,
      icon: <StyledSearchIcon variant="Bold" size="20" />,
    },
    {
      title: "سوالات متداول",
      path: ROUTE.ROUTE_FAQ,
      icon: <MessageQuestion variant="Bold" size="20" />,
      borderTop: true,
    },
    {
      title: "تماس با ما",
      path: ROUTE.ROUTE_CONTACT,
      icon: <Call variant="Bold" size="20" />,
    },
  ];

  return (
    <StyledNavbar fixed="top">
      <DesktopNavbarComponent
        className="d-none d-lg-flex"
        handleLogoutUser={handleLogoutUser}
        location={location}
        user={user}
        profileDetails={profileDetails}
        list={profileListItems}
      />
      <ResponsiveNavbarComponent
        className="d-flex d-lg-none"
        location={location}
        user={user}
        profileDetails={profileDetails}
        list={
          !user.isLogin ? sideBarList : [...sideProfileListItems, ...sideBarList]
        }
      />
    </StyledNavbar>
  );
};

export default NavbarContainer;
